import { render, staticRenderFns } from "./RelatoriosHomeView.vue?vue&type=template&id=88d7b1f8&scoped=true"
import script from "./RelatoriosHomeView.vue?vue&type=script&lang=js"
export * from "./RelatoriosHomeView.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosHomeView.vue?vue&type=style&index=0&id=88d7b1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d7b1f8",
  null
  
)

export default component.exports